import type { RouteRecordRaw } from 'vue-router'
import { EPage } from '@/shared/enum/page.enum'
import { ROUTES_GUARDS } from '@/router/mcapp/guards'

export const routesMcapp: RouteRecordRaw[] = [
  {
    path: '/maintenance',
    component: () => import('@/maintenance/pages/MaintenancePage.vue'),
    name: EPage.MAINTENANCE
  },
  {
    path: '/',
    name: EPage.ROOT,
    redirect: { name: EPage.BLANK },
    component: () => import('@/components/layouts/MCAppLayout.vue'),
    children: [
      {
        path: '',
        name: EPage.BLANK,
        component: () => import('@/blank/BlankPage.vue'),
        beforeEnter: ROUTES_GUARDS[EPage.BLANK]
      },
      {
        path: 'sendRecharges',
        name: EPage.SEND_RECHARGES,
        beforeEnter: ROUTES_GUARDS[EPage.SEND_RECHARGES],
        component: () => import('@/send-recharges/pages/SendRechargesPage.vue')
      },
      {
        path: 'packages',
        name: EPage.PACKAGES,
        beforeEnter: ROUTES_GUARDS[EPage.PACKAGES],
        component: () => import('@/packages/pages/PackagesPage.vue')
      },
      {
        path: 'microcredits',
        name: EPage.MICROCREDITS,
        beforeEnter: ROUTES_GUARDS[EPage.MICROCREDITS],
        component: () => import('@/microcredits/pages/MicrocreditsPage.vue')
      },
      {
        path: 'result/:folio',
        name: EPage.RESULT,
        beforeEnter: ROUTES_GUARDS[EPage.RESULT],
        component: () => import('@/result/pages/ResultPage.vue')
      },
      {
        path: 'genericError',
        name: EPage.GENERIC_ERROR,
        beforeEnter: ROUTES_GUARDS[EPage.GENERIC_ERROR],
        component: () => import('@/generic-error/pages/GenericErrorPage.vue')
      },
      {
        path: 'terms',
        name: EPage.TERMS,
        beforeEnter: ROUTES_GUARDS[EPage.TERMS],
        component: () => import('@/terms/pages/TermsPage.vue')
      },
      {
        path: 'payForm/:payForm/:folio',
        name: EPage.PAYMENT_FORM,
        beforeEnter: ROUTES_GUARDS[EPage.PAYMENT_FORM],
        component: () => import('@/payment-form/page/PaymentFormPage.vue')
      },
      {
        path: 'generateFolio',
        name: EPage.GENERATE_FOLIO,
        beforeEnter: ROUTES_GUARDS[EPage.GENERATE_FOLIO],
        component: () => import('@/generate-folio/GenerateFolio.vue')
      },
      {
        path: 'invoice',
        name: EPage.INVOICE,
        beforeEnter: ROUTES_GUARDS[EPage.INVOICE],
        component: () => import('@/invoice/pages/InvoicePage.vue')
      },
      {
        path: 'latePayment',
        name: EPage.LATE_PAYMENT,
        beforeEnter: ROUTES_GUARDS[EPage.LATE_PAYMENT],
        component: () => import('@/late-payment/pages/LatePaymentPage.vue')
      },
      {
        path: 'exit',
        name: EPage.EXIT,
        beforeEnter: ROUTES_GUARDS[EPage.EXIT],
        component: () => import('@/exit/Exit.vue')
      },
      {
        path: ':pathMatch(.*)*',
        name: EPage.NOT_FOUND,
        component: () => import('@/not-found/pages/NotFoundPage.vue')
      }
    ]
  }
]
